import React from 'react'

import { Text, Color, FontWeight, Space, Box, DisplayPosition } from '@gousto-internal/citrus-react'

import { InputFrame, SvgStyled } from '../../CheckoutFrame.styled'

type FrameFieldProps = {
  header: string
  hasLockIcon?: boolean
  dataFrames: string
  errorDataTesting: string
  errorMessage: string
  showError: boolean
}

export const FrameField = ({
  header,
  hasLockIcon = false,
  dataFrames,
  errorDataTesting,
  errorMessage,
  showError,
}: FrameFieldProps) => (
  <Box paddingV={1}>
    <Text fontWeight={FontWeight.Bold}>{header}</Text>
    <Space direction="vertical" size={2} />
    <Box position={hasLockIcon ? DisplayPosition.Relative : undefined}>
      <InputFrame data-frames={dataFrames} />
      {hasLockIcon && (
        <Box position={DisplayPosition.Absolute} top="0.7rem" right="0.5rem" height="100%">
          <SvgStyled fileName="icon-checkout-lock" />
        </Box>
      )}
    </Box>
    <Space direction="vertical" size={2} />
    <Box data-testid={errorDataTesting} data-testing>
      {showError && (
        <Text size={1} color={Color.Error_900}>
          {errorMessage}
        </Text>
      )}
    </Box>
  </Box>
)
